import fetch from "lib/fetch";
import type { FileResponseInterface } from "types/file";

export const getFileRequest = (id: string) =>
    fetch.get<{ data: FileResponseInterface }>(`file/${id}`);

export const getFileBySlugRefRequest = (slugRefFile: string) =>
    fetch.get<{ data: unknown }>(`file/ressource/${slugRefFile}`);
